export default __webpack_public_path__ + "static/media/heading-logo.cf2de3e7.png";